import React, { useState } from 'react';
import './App.css';
import { useSmoothScroll } from './hooks/useSmoothScroll';
import { Header } from './components/shared/Header';
import { CompassHUD } from './components/shared/CompassHUD';
import { SceneTransition } from './components/shared/SceneTransition';
import { Scene0Orientation } from './components/scenes/Scene0Orientation';
import { Scene1Leak } from './components/scenes/Scene1Leak';
import { Scene2Fix } from './components/scenes/Scene2Fix';
import { Scene3Flow } from './components/scenes/Scene3Flow';
import { Scene4Future } from './components/scenes/Scene4Future';
import { Scene5Decision } from './components/scenes/Scene5Decision';

function App() {
  // Initialize Lenis smooth scrolling with GSAP integration
  useSmoothScroll();

  const [currentScene, setCurrentScene] = useState(0);
  const [scrollProgress, setScrollProgress] = useState(0);

  const sceneNames = [
    'Orientation',
    'The Leak',
    'The Fix',
    'Flow',
    'Future',
    'Decision',
  ];

  return (
    <div className="App min-h-screen">
      {/* Fixed Header with Logo */}
      <Header />

      {/* Persistent Compass HUD */}
      <CompassHUD
        currentScene={currentScene}
        progress={scrollProgress}
        sceneNames={sceneNames}
      />

      {/* Scene Transition Wrapper */}
      <SceneTransition currentScene={currentScene}>
        {/* Scene 0: Orientation */}
        <Scene0Orientation
          onSceneChange={setCurrentScene}
          onProgressUpdate={setScrollProgress}
        />

        {/* Scene 1: The Leak */}
        <Scene1Leak
          onSceneChange={setCurrentScene}
          onProgressUpdate={setScrollProgress}
        />

        {/* Scene 2: The Fix */}
        <Scene2Fix
          onSceneChange={setCurrentScene}
          onProgressUpdate={setScrollProgress}
        />

        {/* Scene 3: Flow */}
        <Scene3Flow
          onSceneChange={setCurrentScene}
          onProgressUpdate={setScrollProgress}
        />

        {/* Scene 4: Future */}
        <Scene4Future
          onSceneChange={setCurrentScene}
          onProgressUpdate={setScrollProgress}
        />

        {/* Scene 5: Decision */}
        <Scene5Decision
          onSceneChange={setCurrentScene}
          onProgressUpdate={setScrollProgress}
        />
      </SceneTransition>
    </div>
  );
}

export default App;